import { buildUrl } from 'vueDir/helpers';
const CRMListings = [
    {
        id: 'client',
        label: window.i18n.__('Clients'),
        buttons: [
            {
                label: window.i18n.__('Ajouter un client'),
                href: "javascript:Third.create('client')",
                primary: true,
                disabled: true,
                permission: 'create',
            },
            {
                label: window.i18n.__('Importer des clients'),
                href: '/settings/imports?importType=company',
                disabled: false,
            },
        ],
        exportOptions: {
            'export-annotations': window.i18n.__('Je souhaite exporter les commentaires liés'),
        },
        linkedtype: 'third',
        name: 'clients',
        params: {
            type: 'client',
        },
        savedSearchesUrl: '/savedsearch/clients',
        switchDisplay: [
            {
                id: 'liste-view',
                action: 'toggleMap',
                icon: 'menu',
                label: window.i18n.__('Vue liste'),
                selected: true,
            },
            {
                id: 'map-view',
                action: 'toggleMap',
                icon: 'location',
                label: window.i18n.__('Vue carte'),
                selected: false,
            },
        ],
        group: 'crm',
        favoritesName: 'clients',
        mapname: 'clientsmap',
    },
    {
        id: 'prospect',
        label: window.i18n.__('Prospect'),
        buttons: [
            {
                label: window.i18n.__('Ajouter un prospect'),
                href: "javascript:Third.create('prospect')",
                primary: true,
                disabled: true,
                permission: 'create',
            },
            {
                label: window.i18n.__('Importer des prospects'),
                href: '/settings/imports?importType=company',
                disabled: false,
            },
        ],
        exportOptions: {
            'export-annotations': window.i18n.__('Je souhaite exporter les commentaires liés'),
        },
        linkedtype: 'third',
        name: 'prospects',
        params: {
            type: 'prospect',
        },
        savedSearchesUrl: '/savedsearch/prospects',
        switchDisplay: [
            {
                id: 'liste-view',
                action: 'toggleMap',
                icon: 'menu',
                label: window.i18n.__('Vue liste'),
                selected: true,
            },
            {
                id: 'map-view',
                action: 'toggleMap',
                icon: 'location',
                label: window.i18n.__('Vue carte'),
                selected: false,
            },
        ],
        group: 'crm',
        mapname: 'prospectsmap',
        favoritesName: 'prospects',
    },
    {
        id: 'supplier',
        label: window.i18n.__('Supplier'),
        buttons: [
            {
                label: window.i18n.__('Ajouter un fournisseur'),
                href: "javascript:Third.create('supplier')",
                primary: true,
                disabled: true,
                permission: 'create',
            },
            {
                label: window.i18n.__('Importer des fournisseurs'),
                href: '/settings/imports?importType=company',
                disabled: false,
            },
        ],
        exportOptions: {
            'export-annotations': window.i18n.__('Je souhaite exporter les commentaires liés'),
        },
        linkedtype: 'third',
        name: 'suppliers',
        params: {
            type: 'supplier',
        },
        savedSearchesUrl: '/savedsearch/suppliers',
        switchDisplay: [
            {
                id: 'liste-view',
                action: 'toggleMap',
                icon: 'menu',
                label: window.i18n.__('Vue liste'),
                selected: true,
            },
            {
                id: 'map-view',
                action: 'toggleMap',
                icon: 'location',
                label: window.i18n.__('Vue carte'),
                selected: false,
            },
        ],
        group: 'crm',
        mapname: 'suppliersmap',
        favoritesName: 'suppliers',
    },
    {
        id: 'company',
        label: window.i18n.__('Company'),
        buttons: [],
        enableExport: true,
        exportOptions: {
            'export-annotations': window.i18n.__('Je souhaite exporter les commentaires liés'),
        },
        linkedtype: 'third',
        name: 'companies',
        params: {
            type: 'company',
        },
        savedSearchesUrl: '/savedsearch/companies',
        switchDisplay: [
            {
                id: 'liste-view',
                action: 'toggleMap',
                icon: 'menu',
                label: window.i18n.__('Vue liste'),
                selected: true,
            },
            {
                id: 'map-view',
                action: 'toggleMap',
                icon: 'location',
                label: window.i18n.__('Vue carte'),
                selected: false,
            },
        ],
        group: 'crm',
        mapname: 'companiesmap',
        favoritesName: 'companies',
    },
    {
        id: 'individual',
        label: window.i18n.__('Individual'),
        buttons: [],
        enableExport: true,
        exportOptions: {
            'export-annotations': window.i18n.__('Je souhaite exporter les commentaires liés'),
        },
        linkedtype: 'third',
        name: 'individuals',
        params: {
            type: 'individual',
        },
        savedSearchesUrl: '/savedsearch/individuals',
        switchDisplay: [
            {
                id: 'liste-view',
                action: 'toggleMap',
                icon: 'menu',
                label: window.i18n.__('Vue liste'),
                selected: true,
            },
            {
                id: 'map-view',
                action: 'toggleMap',
                icon: 'location',
                label: window.i18n.__('Vue carte'),
                selected: false,
            },
        ],
        group: 'crm',
        mapname: 'individualsmap',
        favoritesName: 'individuals',
    },

    {
        id: 'people',
        label: window.i18n.__('Contact'),
        buttons: [
            {
                label: window.i18n.__('Ajouter un contact'),
                href: "javascript:People.edit('listing');",
                primary: true,
                disabled: true,
                permission: 'create',
            },
            {
                label: window.i18n.__('Importer des contacts'),
                href: '/settings/imports?importType=contact',
                disabled: false,
            },
        ],
        exportOptions: {
            'export-annotations': window.i18n.__('Je souhaite exporter les commentaires liés'),
        },
        linkedtype: 'people',
        name: 'people',
        savedSearchesUrl: '/savedsearch/people',
        group: 'crm',
    },

    {
        id: 'opportunity',
        label: window.i18n.__('Opportunités'),
        buttons: [
            {
                label: window.i18n.__('Créer une opportunité'),
                href: 'javascript:Opportunity.addOpportunity();',
                primary: true,
                disabled: true,
                permission: 'create',
            },
        ],
        exportOptions: {
            'export-annotations': window.i18n.__('Je souhaite exporter les commentaires liés'),
        },
        linkedtype: 'opportunity',
        name: 'opportunities',
        savedSearchesUrl: '/savedsearch/opportunities',
        group: 'prospection',
    },

    {
        id: 'pipeline',
        label: window.i18n.__('Pipeline'),
        buttons: [
            {
                label: window.i18n.__('Créer une opportunité'),
                href: 'javascript:Opportunity.addOpportunity();',
                primary: true,
                disabled: true,
                permission: 'create',
            },
        ],
        linkedtype: 'opportunities',
        name: 'pipelines',
        savedSearchesUrl: '/savedsearch/pipeline',
        group: 'prospection',
        funnel: false,
    },
];

export default CRMListings;
